module.exports = __webpack_public_path__ + "img/Curso_ExamenInternacional.a8d8a825.png";